module.exports = __webpack_public_path__ + "img/hn.23b25092.png";